import Content from './Content';
import Sidebar from './Sidebar';

const OrderingForm = () => {
  return (
    <div className="legacy mx-auto mb-4">
      <div className="ordering_form">
        <Content />
        <Sidebar />
      </div>
    </div>
  );
};

export default OrderingForm;
